import { MDText } from 'i18n-react';

import { FINANCE_PAYMENT_DETAILS_ROUTE } from 'Utilities/routing';

import Artwork from '../../../../../../../client/assets_seller/illustrations/coins.svg';
import { ActionCenter } from '../../../../vehicleCollection/components/ActionCenter/ActionCenter';
import { useIsPayDealer } from '../../../../vehicleCollection/hooks/useIsPayDealer';
import { useSaleDetailsSub } from '../../../../vehicleCollection/hooks/useSaleDetailsSub';
import { useVehicleCollectionSub } from '../../../../vehicleCollection/hooks/useVehicleCollectionSub';

import LocalTexts from './PayNegativeEquityActionCenter.texts.json';

import styles from './PayNegativeEquityActionCenter.module.scss';

const LocalT = new MDText(LocalTexts);

export const PayNegativeEquityActionCenterCard = () => {
  const { vrm } = useVehicleCollectionSub();

  return (
    <div className={styles.wrapper}>
      <ActionCenter
        data-pay-ne
        ctaIcon="arrow"
        ctaLabel={LocalT.translate('cta')}
        data-testid="pay-ne"
        description={LocalT.translate('subheading')}
        heading={LocalT.translate('heading')}
        image={Artwork}
        url={{
          target: '_self',
          to: `/${vrm}${FINANCE_PAYMENT_DETAILS_ROUTE}`,
        }}
        variant='yellow'
      />
    </div>
  );
};

export const PayNegativeEquityActionCenter = () => {
  const { hasNegativeEquity } = useSaleDetailsSub();
  const { isNESettled, isSaleComplete } = useVehicleCollectionSub();
  const isPayDealer = useIsPayDealer();

  if (!hasNegativeEquity || !isPayDealer) {
    return null;
  }

  if (isNESettled || isSaleComplete) {
    return null;
  }

  return (
    <PayNegativeEquityActionCenterCard />
  );
};
